import Actions from '../../action'
const initialState = {
    isLoading: false,
    error: false,
    selectedAccents: {
        button: 'j8',
        hole: 'black',
        thread: 'black',
        selectedButtonsThreads: 'default',
        fill: "#000000",
        font: "Calibri",
        initials: "",
        suitInnerFabric: 'gid://shopify/Product/6759393001636',
        selectedSuitLining: 'default',
        selectedPocketSquare: 'without',
        pocketSquareFabric: 'gid://shopify/Product/6759386448036',
        pocketFabricName: '1000-16',
        liningFabricName: null
    }
}
export default (state = initialState, action) => {
    switch (action.type) {
        case Actions.UPDATE_SUIT_ACCENTS: {
            let { selectedAccents } = state
            return {
                ...state,
                selectedAccents: {
                    ...selectedAccents,
                    [action.key]: action.data
                },
            };
        } case Actions.EDIT_SUIT_ACCENTS: {
            return {
                ...state,
                selectedAccents: action.data,
            };
        }
        case Actions.RESET_CANVAS: {
            return {
                ...state,
                ...initialState
            }
        } case Actions.RESET_STYLE: {
            return {
                ...state,
                ...initialState
            }
        }
        default:
            return state;
    }

};